import React, { ReactElement } from 'react';
import AppBarInternal from '@mui/material/AppBar';
import FormatService from '../../services/format-service';
import useStylesAppBar from './app-bar.styles';

const AppBar: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const COLOR_PRIMARY: ThemeColor = 'primary';
  const POSITION_FIXED: AppBarPosition = 'fixed';

  const {
    isActive,
    children,
  } = props;

  const { classes } = useStylesAppBar();

  const activeClassName: string | undefined = isActive ? classes.appBarActive : classes.appBarDefault;

  return (
    <AppBarInternal
      color={COLOR_PRIMARY}
      position={POSITION_FIXED}
      classes={{
        root: FormatService.formatClassNames(classes.appBar, activeClassName),
      }}
    >
      {children}
    </AppBarInternal>
  );
});

export default AppBar;
